// extracted by mini-css-extract-plugin
export default {"header":"suNoBd","successActions":"Lc8prx","desktop":"pFPV_H","title":"pAB_st","mobile":"mm0SkM","spinnerContainer":"v6AQNp"};